
<div
  class="card-image"
  :class="{ clickable: $listeners.click }"
  v-bind="$attrs"
  v-on="$listeners"
>
  <div class="image-container">
    <img
      class="fade"
      v-lazy="{ src: imageUrl, error: lightErrorImage }"
      :alt="alt"
    />
  </div>
</div>
